var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleCiderVinegar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC15D;}\n\t.st1{fill:#86574B;}\n\t.st2{fill:#A52632;}\n\t.st3{fill:#E7E6E6;}\n\t.st4{fill:#F8EEE1;}\n\t.st5{fill:#DD2F45;}\n\t.st6{fill:#662115;}\n\t.st7{fill:#519C34;}\n\t.st8{fill:#1E8755;}\n\t.st9{fill:#EC655E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.31,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.01,151.26,61.62,185.55,104.31,185.55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.46,51.87H95.29c-0.68,0-1.32,0.28-1.72,0.76c-3.68,4.36,3.82,12.4,5.36,13.97c0.41,0.42,1,0.65,1.62,0.65 h12.64c0.63,0,1.22-0.24,1.62-0.65c1.54-1.57,9.04-9.61,5.36-13.97C119.78,52.15,119.14,51.87,118.46,51.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.29,124.4c-3.91-10.98-16.25-25.48-19.23-28.9l1.96-17.55l6.73-7.68h0.21c1.77,0,3.21-1.26,3.21-2.82 s-1.44-2.82-3.21-2.82H90.71c-1.77,0-3.21,1.26-3.21,2.82s1.44,2.82,3.21,2.82h0.21l1.05,8.38c-1.66-0.41-3.5-0.46-5.46-0.08 c-5.45,1.07-10.42,4.94-12.36,9.65c-2,4.84-1.07,10.92,2.3,15.14c2.01,2.51,4.68,4.07,7.65,4.62c-3.7,5.27-7.39,11.27-9.23,16.43 c-2.52,7.07,0.61,16.66,3.68,23.45c1.49,3.31,3.5,7.01,5.4,9.94c-1.4,0.3-2.45,1.41-2.45,2.73c0,1.55,1.44,2.82,3.21,2.82h4.98 h30.84h3.57c1.77,0,3.21-1.26,3.21-2.82c0-0.94-0.53-1.77-1.34-2.28c1.98-3,4.1-6.92,5.67-10.4 C134.7,141.05,137.81,131.47,135.29,124.4z M86.42,103.38c-2.63,0-4.4-1.52-5.42-2.8c-2.35-2.93-3.02-7.33-1.63-10.69 c1.45-3.52,5.3-5.96,8.35-6.56c1.27-0.25,3.03-0.32,4.24,0.74c0.22,0.19,0.48,0.32,0.75,0.44l1.34,10.67 c-1.16,1.36-3.75,4.45-6.7,8.36C87.05,103.45,86.75,103.38,86.42,103.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.77,145.46c-1.44,3.24-3.44,6.87-5.22,9.57l-1.22,1.85h-7.43c6.84-10.31,2.44-33.14-1.22-44.49h10.69 c3.48,4.96,6.44,9.92,7.88,13.94C129.69,130.38,128.39,137.35,124.77,145.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.9,156.87H91.85l-1.44-2.27c-1.74-2.66-3.59-6.06-4.96-9.11c-3.7-8.14-4.96-15.11-3.51-19.13 c1.29-3.63,3.96-8.46,7.77-13.98h19.97C113.34,123.73,117.74,146.56,110.9,156.87z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M99.54,122.59c2.72,0,2.72,0.91,5.45,0.91c2.73,0,2.72-0.91,5.45-0.91c3.63,0,8.17,1.82,8.17,8.17 c0,9.99-5.45,18.17-9.08,18.17c-2.72,0-2.72-0.91-4.54-0.91c-1.82,0-1.82,0.91-4.54,0.91c-3.63,0-9.08-8.17-9.08-18.17 C91.36,124.41,95.91,122.59,99.54,122.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M104.99,125.32c0.5,0,0.91-0.41,0.91-0.91l0,0c0-3.13-1.09-6.01-2.99-7.91c-0.35-0.35-0.93-0.35-1.28,0 c-0.35,0.35-0.35,0.93,0,1.28c1.56,1.56,2.46,3.98,2.46,6.62C104.08,124.91,104.49,125.32,104.99,125.32L104.99,125.32"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M102.87,124.04c-5.19,5.63-10.84-2.56-10.84-2.56C100.28,117.61,102.87,124.04,102.87,124.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M91.04,122.16c0.13,0.19,3.24,4.63,7.28,5.02c1.84,0.18,3.55-0.48,5.07-1.96c0.12-0.12,0.25-0.25,0.37-0.38 c0.32-0.34,0.41-0.83,0.23-1.27c-0.05-0.12-1.17-2.83-4.18-4.01c-2.36-0.93-5.15-0.65-8.29,0.82c-0.32,0.15-0.56,0.43-0.65,0.77 C90.78,121.51,90.84,121.87,91.04,122.16z"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 111.29,
    cy: 130.28,
    rx: 3.81,
    ry: 4.09
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleCiderVinegar);
export default __webpack_public_path__ + "static/media/Apple_cider_vinegar.ec170b3f594b93cdbf7b75d0a402e2aa.svg";
export { ForwardRef as ReactComponent };